import styled from 'styled-components';
export const StyledSearchControls = styled.div.withConfig({
  displayName: "StyledSearchControls",
  componentId: "sc-144l1di-0"
})(["flex-flow:row nowrap;position:absolute;top:50%;transform:translateY(-50%);right:", ";display:flex;align-items:center;justify-content:center;"], ({
  theme
}) => theme.space[300]);